"use client";

import { App } from 'antd';

export const useNotification = () => {
  const { notification } = App.useApp();

  return {
    success: (message: string) => {
      setTimeout(() => {
        notification.success({ message });
      }, 0);
    },
    error: (message: string) => {
      setTimeout(() => {
        notification.error({ message });
      }, 0);
    },
    info: (message: string) => {
      setTimeout(() => {
        notification.info({ message });
      }, 0);
    },
    warning: (message: string) => {
      setTimeout(() => {
        notification.warning({ message });
      }, 0);
    },
    notification: notification
  };
};